import type { FaireProductEntity } from "../../entity_types/product";

export const p_g54r83hxhc: FaireProductEntity = {
  token: "p_g54r83hxhc",
  type: "product",
  name: "Magnesium Mist | Sore Muscle & Sleep Support Spray",
  brandToken: "b_6qmzxvyma9",
  brandName: "Wild Roots Tallow Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/62286beeab6defd340fd00713da5f24b09892f318cc3917b48baf92dca4a9d28.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dfc9f6455f45c13ccce41e1a833ce0f6e96679124fbf57b374af50c86ce3e038.jpeg",
    "https://cdn.faire.com/fastly/594d3bce1245bb8f1899a792684541c4ea87821829206ef5f5ccf24c4ff456f4.png",
    "https://cdn.faire.com/fastly/5759ab4e1a4f8e8ca7c5691f4e3e2804f31a56f9de4742f88ab8b256c97bc02f.png",
    "https://cdn.faire.com/fastly/740793bd5ef3fe42b4aedad945757018656c49b9b6ab52037cbe52b2c87941c6.png",
  ],
  priceDollars: 11.09,
  description:
    "A light, fast-absorbing magnesium body mist designed to relieve sore muscles and promote relaxation and restful sleep.\nPerfect for evening routines, post-workout recovery, or anytime you need a relaxing, restorative boost. Lightweight and non-greasy, it absorbs quickly and can be sprayed directly on tense muscles or over the body before bedtime.\n\nKey Benefits\nSupports sore muscles and tension relief\nPromotes relaxation and restful sleep\nFast-absorbing, lightweight spray\nHydrates and soothes skin\nClean, functional, and non-toxic\n\nWhy Retailers Love It\nFunctional magnesium sprays are in high demand in wellness retail. This product appeals to customers seeking natural solutions for recovery, relaxation, and sleep, making it a high-repeat purchase item for clean beauty and wellness stores.\n",
  tags: [],
  msrpDollars: 24.94,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:44.475Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
